// extracted by mini-css-extract-plugin
export default {"form":"ApplicantNoteSpace_form__4525q"};